import { addBreadcrumb, type SeverityLevel } from '@sentry/react';

type Recommendation = {
  id?: number;
  processing_status?: string;
  courses?: unknown[];
};

type BreadcrumbContext = {
  recommendation?: Recommendation;
  previousRecommendationId?: number;
};

export const addRecommendationBreadcrumb = (
  message: string,
  context?: BreadcrumbContext,
  level: SeverityLevel = 'info'
) => {
  addBreadcrumb({
    category: 'websocket',
    message,
    level,
    data: context
      ? {
          recommendation_id: context.recommendation?.id,
          processing_status: context.recommendation?.processing_status,
          courses_count: context.recommendation?.courses?.length ?? 0,
          previous_recommendation_id: context.previousRecommendationId,
        }
      : undefined,
  });
};
